import React, { Component } from "react";
import { GoogleLogin } from "react-google-login";
import BackendLoginService from "./backendLoginService";
import { Redirect, Link } from "react-router-dom";

export default class Login extends Component {
  clientId =
    "119044322202-46ojakubusukc4f80ovkehdali45q380.apps.googleusercontent.com";

  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
      clientEmail: "",
      serverEmail: "",
      serverLoginFailed: false,
    };
  }

  onSuccess = (res) => {
    console.log("history:", this.props.history);
    console.log("Client login succesful:", res);

    this.setState({
      clientEmail: res?.profileObj?.email,
      serverLoginFailed: false,
    });
    //alert("Should go back to: " + this.props.location.state.from);
    // this.setState({ email: res.profileObj.email, tokenId: res.tokenId });
    // let email = res?.profileObj?.email;

    BackendLoginService.getInstance()
      .login(res)
      .then((r) => {
        console.log("Server login succesful");
        let redirect = null;
        if (this.props.location.state && this.props.location.state.from) {
          redirect = this.props.location.state.from;
        }

        let email = r.email;
        this.setState({
          redirect: redirect,
          serverEmail: email,
        });

        //alert(BackendLoginService.getInstance().isLoggedIn());
      })
      .catch((error) => {
        this.setState({
          serverEmail: "",
          serverLoginFailed: true,
        });
        console.log(error);
        alert(`Failed to do server login. 😢\n` + error);
      });
  };

  onFailure = (res) => {
    this.setState({
      clientEmail: "",
      serverEmail: "",
    });
    console.log("Login failed: res:", res);
    alert(`Failed to do client login. 😢`);
  };

  renderSuccessAccountInfo = () => {
    return (
      <div className="alert alert-success">
        <p className="card-text">
          Вы вошли как: {this.state.clientEmail}
          <br />
          <Link to="/logout">Выйти</Link>
        </p>
      </div>
    );
  };

  renderFailedAccountInfo = () => {
    return (
      <div className="alert alert-danger">
        <p className="card-text">
          Не удалось войти на сервер как: {this.state.clientEmail}.
          <br />
          Попробуйте выйти и зайти под другим пользователем.
          <br />
          <Link to="/logout">Выйти</Link>
        </p>
      </div>
    );
  };

  renderAccountInfo = () => {
    let isLoggedIn = false;
    try {
      isLoggedIn = BackendLoginService.getInstance().isLoggedIn();
    } catch (e) {
      console.log(e);
    }

    const isSuccess = isLoggedIn;
    const isServerLoginFailed =
      this.state.clientEmail && !isLoggedIn && this.state.serverLoginFailed;
    return isSuccess
      ? this.renderSuccessAccountInfo()
      : isServerLoginFailed
      ? this.renderFailedAccountInfo()
      : null;
  };

  render() {
    if (this.state.redirect) {
      console.log("Redirecting to: " + this.state.redirect);
      return (
        <Redirect
          push
          to={{
            pathname: this.state.redirect,
            // state: { product },
          }}
        />
      );
    }

    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="card">
          <div className="card-body text-center">
            {this.renderAccountInfo()}
            <GoogleLogin
              clientId={this.clientId}
              buttonText="Login"
              onSuccess={this.onSuccess}
              onFailure={this.onFailure}
              cookiePolicy={"single_host_origin"}
              style={{ marginTop: "100px" }}
              isSignedIn={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
